<template>
  <transition name="message-fade">
    <div class="message-box-overlay" v-if="visible" @click="handleClose">
      <div class="message-box" @click.stop>
        <div class="message-text">{{ message }}</div>
        <button class="message-btn" @click="handleClose">确定</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MessageBox',
  data() {
    return {
      visible: false,
      message: '',
      title: '',
      type: 'info',
      duration: 0,
      closed: false,
      onClose: null
    }
  },
  methods: {
    handleClose() {
      this.visible = false
      if (this.onClose) {
        this.onClose()
      }
    }
  }
}
</script>

<style scoped>
.message-box-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.message-box {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 280px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.message-text {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin-bottom: 16px;
  white-space: pre-line;
}

.message-btn {
  width: 100%;
  padding: 12px 24px;
  background: #0066ff;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.message-btn:hover {
  background: #0052cc;
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.2s;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
}
</style>
